import { parseBudgetHours } from '@coneno/c-sheet-shared'
import { Field, FieldDescription, FieldError, FieldLabel } from '@/components/ui/field'
import { Input } from '@/components/ui/input'

export function BudgetField({
  id,
  value,
  onChange,
  disabled
}: {
  id: string
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}): React.JSX.Element {
  const invalid = parseBudgetHours(value) === undefined
  return (
    <Field data-invalid={invalid}>
      <FieldLabel htmlFor={id}>
        Hour budget <span className="text-muted-foreground">(optional)</span>
      </FieldLabel>
      <Input
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="e.g. 120 or 12:30"
        disabled={disabled}
        aria-invalid={invalid}
        aria-describedby={`${id}-help`}
      />
      <FieldDescription id={`${id}-help`}>
        Hours (12.5) or hours:minutes (12:30). Blank means no budget. Time can still be recorded
        beyond the budget.
      </FieldDescription>
      {invalid && (
        <FieldError>
          Enter non-negative hours or hours:minutes, up to 2,147,483,647 minutes, with whole-minute
          precision.
        </FieldError>
      )}
    </Field>
  )
}
